import { recommendedItems } from '@/mocks/homeData';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function ProductRecommendations() {
  const { ref, animated } = useScrollReveal();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="container-custom">
        <div className={`text-center mb-10 md:mb-14 ${animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} style={{ transition: 'all 0.6s ease-out' }} ref={ref}>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            少女心好物推荐
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            编辑部精挑细选的少女心好物，每一件都让人心动不已~
          </p>
        </div>

        <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 stagger-children ${animated ? 'animated' : ''}`}>
          {recommendedItems.map((item) => (
            <div
              key={item.slug}
              className="stagger-item group bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="relative w-full aspect-square overflow-hidden">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-medium whitespace-nowrap">
                  {item.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 line-clamp-1">
                  {item.name}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {item.description}
                </p>
                <div className="flex items-center justify-between mt-4">
                  <span className="text-lg font-bold text-primary-600">{item.price}</span>
                  <div className="flex items-center gap-1">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500 text-sm"></i>
                    </div>
                    <span className="text-xs text-foreground-500">{item.rating}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}